import ITicket from "@/interfaces/ITicket";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import TicketForm from '@/components/Tickets/TicketForm/TicketForm.vue';

@Component({
    name: 'TicketDetail',
    components: {
        TicketForm
    }
})

export default class TicketDetail extends Vue {
    @Prop(String) private modalId!: string;
    @Prop(String) private modalTitle!: string;
    @Prop({type: Boolean, default: false}) private hideFooter!: boolean;
    @Prop(Boolean) private showModal!: boolean;
    @Prop(Object) private ticketData!: ITicket;

    private show: boolean | null = null;

    @Watch('showModal')
    private toggleModal(): void {
        this.show = this.showModal;
    }

    private closeModal(): void {
        this.$emit('closeModalTicket')
    }
}